import { Subscription } from 'rxjs';

export class SmartSubscription {
  private subsriptions: Subscription[] = [];

  set enqueue(value: Subscription) {
    this.subsriptions.push(value);
  }

  add(value: Subscription): void {
    this.subsriptions.push(value);
  }

  unsubscribe() {
    this.subsriptions.forEach((s) => {
      if (s) {
        s.unsubscribe();
      }
    });
  }
}
